<template>
    <div class="main">
        <c-panel>
            <el-form label-position="top"> 
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="18" :md="18">
                        <el-form-item label="Instituição" key="instituicao">
                            <el-select ref="instituicao_id" v-model="instituicao_id" filterable multiple placeholder="Pesquisar Instituição" clearable>
                                <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"> </el-option>
                            </el-select>
                        </el-form-item>                                
                    </el-col>                            
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Data" key="data">
                            <el-date-picker
                                style="width: 100%; margin-top: 2px;"
                                v-model="data"
                                type="date"
                                format="dd/MM/yyyy"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>                            
                </el-row> 
                <div class="u-mt-10">
                    <el-row>
                        <el-col :xs="24" :sm="24" :md="24" class="u-text-right">                        
                            <el-button @click="submitDiaLetivo()" :loading="loading" type="primary">Salvar</el-button>
                        </el-col>
                    </el-row>
                </div>
            </el-form>
        </c-panel>
    </div>
</template>
<script>
import cPanel from '../../../shared/c-panel/c-panel.vue';

export default {
  components: { cPanel },
    data: () => ({
        tabAtivo: 'filtros',
        loading: false,        
        instituicao_id: [],            
        data: '',        
        paginate: {
            page: 1,
            qtdItens: null,
            from: '',
            to: ''
        },
        itens: [ ]  
    }),
    mounted () {         
    },
    methods: {            
        async submitDiaLetivo(){          
            

            if(this.data == ''){

                window.eventBus.$emit('alert', {msg: 'Insira uma data valida.', type: 'warning'});
                return;
            }

            if(this.instituicao_id.length < 1){

                let response = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/instituicao/getAllInstituicoesAtivas`, this.$store.getters.getHeaderAuth).then(res => res.data);

                for(let i in response){

                    this.instituicao_id.push(response[i].id);
                }  
                
            }               

            try{

                this.loading = true;

                let response = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/instituicao/addDiaLetivo`, {

                    instituicao_id: this.instituicao_id,
                    data: this.data,

                }, this.$store.getters.getHeaderAuth);

                this.loading = false;

                window.eventBus.$emit('alert', {msg: 'Dia letivo salvo com sucesso.', type: 'success'});
                this.$router.push('/')
               

            }catch(e){

                window.eventBus.$emit('alert', {msg: 'Erro ao salvar dia letivo.', type: 'warning'});
            }

        }
    }
}
</script>